(function () {
	"use strict";

	function Arrow() {
		this.Container_constructor();
		this.width = cm.app.display.width * 0.5;
		this.height = cm.app.display.height * 0.5;
		this.arrowSetPos = 0;
		this.name = "Arrow";
		this.arrowCont = new cjs.Container();
	}

	var p = createjs.extend(Arrow, cjs.Container);

	p.createArrows = function (cx, cy, container) {

		this.arrowCont = new cjs.Container();
		this.arrowCont.x = cx;
		this.arrowCont.y = cy;

		var xPos = 10;
		for (var i = 0, l = 14; i < l; i++) {
			if (i > 4) {
				var arrow = new cjs.Sprite(cm.Assets.lib.gameSS, "arrow");
				arrow.x = xPos;
				arrow.y = 0;
				arrow.visible = false;
				this.arrowCont.addChild(arrow);
			}

			xPos += 50;
		}

		container.addChild(this.arrowCont);

	};

	p.keyPressLaunchArrow = function (angle)
	{
		var obstacle = cm.ViewControl.current.obstacleBox1;
		var obstacle1 = cm.ViewControl.current.obstacleBox2;
		this.arrowCont.rotation = angle;
		var child = this.arrowCont.children;
		var point, point1;
		for (var i = 0, l = child.length; i < l; i++) {
			var arrow = this.arrowCont.getChildAt(i);
			var arrowPoint = arrow.localToGlobal(arrow.x, arrow.y);
			if(obstacle)
				point = arrow.parent.localToLocal(arrow.x, arrow.y, obstacle.displayObject);
			if(obstacle1)
				point1 = arrow.parent.localToLocal(arrow.x, arrow.y, obstacle1.displayObject);


			if (arrowPoint.y - this.height > 500 || arrowPoint.y - this.height < -450) {
				this.getReflectiveAngle(arrow);
				arrow.visible = false;

			}
			else {
				if (obstacle && obstacle.displayObject.hitTest(point.x, point.y) || obstacle1 && obstacle1.displayObject.hitTest(point1.x, point1.y)) {
					arrow.visible = false;
					return;
				} else {
					arrow.visible = true;
				}

			}
		}

	};

	p.launchArrow = function (pt, cx, cy) {
		this.arrowCont.x = cx;
		this.arrowCont.y = cy;
		var ax = cx - pt.x;
		var ay = cy - pt.y;
		var theta = Math.atan2(ay, ax);
		var angle = Math.limit(theta, -60, 60);
		var deg = Math.toDeg(angle);

		var obstacle = cm.ViewControl.current.obstacleBox1;
		var obstacle1 = cm.ViewControl.current.obstacleBox2;
		this.arrowCont.rotation = deg - 180;
		var child = this.arrowCont.children;
		var point, point1;
		for (var i = 0, l = child.length; i < l; i++) {
			var arrow = this.arrowCont.getChildAt(i);
			var arrowPoint = arrow.localToGlobal(arrow.x, arrow.y);
			if(obstacle)
				point = arrow.parent.localToLocal(arrow.x, arrow.y, obstacle.displayObject);
			if(obstacle1)
				point1 = arrow.parent.localToLocal(arrow.x, arrow.y, obstacle1.displayObject);


			if (arrowPoint.y - this.height > 500 || arrowPoint.y - this.height < -450) {
				this.getReflectiveAngle(arrow);
				arrow.visible = false;

			}
			else {
				if (obstacle && obstacle.displayObject.hitTest(point.x, point.y) || obstacle1 && obstacle1.displayObject.hitTest(point1.x, point1.y)) {
					arrow.visible = false;
					return;
				} else {
					arrow.visible = true;
				}

			}
		}

	};

	p.getReflectiveAngle = function (arrow) {

		var indexNum = this.arrowCont.getChildIndex(arrow);
		this.lastArrow = this.arrowCont.getChildAt(indexNum - 1);
		if (this.lastArrow) {
			var pointOld = arrow.localToGlobal(arrow.x, arrow.y);
			var lastArrowPos = this.lastArrow.localToGlobal(this.lastArrow.x, this.lastArrow.y);
			var ax = (lastArrowPos.x - this.width) - (pointOld.x - this.width);
			var ay = (lastArrowPos.y - this.height) - (pointOld.y - this.height);
			var theta = Math.atan2(ay, ax);
			var deg = Math.toDeg(theta);
			var newAng = 180 - deg;
			var isVisible = true;
			if (lastArrowPos.y - this.height > 500 || lastArrowPos.y - this.height < -450)
				isVisible = false;
			this.handleArrowAngle(newAng, this.lastArrow, isVisible);
		}

	};

	p.handleArrowAngle = function (newAng, pos, isVisible) {

		var child;
		var angleArrowCont = new cjs.Container();
		var xPos = 0;
		var arrow, i, l;
		for (i = 0, l = 10; i < l; i++) {
			if (i > 4) {
				arrow = new cjs.Sprite(cm.Assets.lib.gameSS, "arrow").center();
				arrow.x = xPos;
				arrow.y = 0;
				angleArrowCont.addChild(arrow);
			}

			xPos += 50;
		}
		this.arrowCont.addChild(angleArrowCont);
		angleArrowCont.regX = xPos * 0.5;
		angleArrowCont.regY = 0;
		child = this.arrowCont.children;
		for (i = child.length - 1; i >= 0; i--) {
			arrow = this.arrowCont.getChildAt(i);
			if (arrow.visible) {
				angleArrowCont.x = this.lastArrow.x + 60;
				angleArrowCont.y = this.lastArrow.y;
			}
		}
		angleArrowCont.visible = isVisible;
		var pt = angleArrowCont.globalToLocal(this.arrowSetPos.x, 330);
		var percent = Math.abs(180 / newAng);

		angleArrowCont.rotation = newAng * 2;

	};

	p.update = function (delta, e) {

	};



	p.kill = function () {

	};
	cm.Arrow = cjs.promote(Arrow, "Container");
})();